import styled from '@emotion/styled';

export default styled.span`
  position: absolute;
  left: -100000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;
